export const LOCAL_STORAGE_USER_DATA = 'user_data';
export const LOCAL_STORAGE_API_KEY = 'api_key';